import { distance } from "@turf/turf";
import { formatTime, getYYYYMMDD } from "../utils/timeUtils";
import { reverseGeocodingWithGranularity } from "../utils/mapboxUtiltiy";

/**
 * 10分ティックで三時間菌を観測して記録する
 */
// パラメータ
const radiusuBuffer = 200; // 集計半径のバッファ(m)
class Recorder {
    /**
     * コンストラクタ
     * @param {*} currentTimestamp 記録開始時刻
     * @param {*} centerLat 観測中心点
     * @param {*} centerLng 
     * @param {Array(Stop)} allStops すべてのStop
     * @param {number} radiusToRecord 集計対象の地理的半径(m) 
     */

    #isDateChanged = false; // 記録開始してから日付を超えたか
    #isCompleted = false; // 24時間分の記録が完了したか

    constructor(currentTimestamp,centerLat,centerLng,allStops,radiusToRecord){
        this.recordStartTimestamp = currentTimestamp; // 記録開始タイムスタンプ
        this.lat = centerLat;
        this.lng = centerLng;
        this.r = radiusToRecord;
        this.area = (radiusToRecord/1000) ** 2 * Math.PI; // 面積
        const defined = Recorder.#defineTargetStop(centerLat,centerLng,allStops,radiusToRecord);
        this.fullys = defined.fully;
        this.particals = defined.partical;
        this.datas = []; // [frameData,]
        this.yyyymmdd = getYYYYMMDD();
        this.hhmmss = formatTime(currentTimestamp); 
        this.recordId = `${Math.floor(1000 + Math.random() * 9000)}-${Math.floor(1000 + Math.random() * 9000)}`; // それっぽい調査番号（特に意味なし）
        // 非同期で逆ジオコーディング結果を取得
        reverseGeocodingWithGranularity(centerLat, centerLng).then((result) => {
            this.address = result ? result : "不明";
            console.log("逆ジオコーディング結果:", this.address);
        }).catch((error) => {
            this.address = "不明";
        });
        console.log("初期化完了しました",this.hours);
    }

    /**
     * 記録を実行する
     * @param {*} currentTimestamp 
     * @returns 
     */
    doIt(currentTimestamp){
        if (this.#isCompleted){ return true }; // 記録が完了している

        if (!this.#isDateChanged && currentTimestamp < this.recordStartTimestamp){
            this.#isDateChanged = true; // 日付を超えた記録
        }

        if (this.#isDateChanged && currentTimestamp > this.recordStartTimestamp){ // 24時間経過したら
            this.#isCompleted = true; // 24時間経過でフラグチェンジ
            return true;
        }

        // そのフレームのデータを格納する
        const typeFrameData = new Map();
        const nameFrameData = new Map();
        this.fullys.map((stop) => typeFrameData.set(stop.route_type,0));
        this.fullys.map((stop) => nameFrameData.set(stop.route_name,0)); 
        this.particals.map((stop) => typeFrameData.set(stop.route_type,0));
        this.particals.map((stop) => nameFrameData.set(stop.route_name,0));
        // 1.完全内包のStop所属菌をカウント
        this.fullys.map((stop) => {
            for (const bacteria of stop.bacterias){
                typeFrameData.set(stop.route_type,typeFrameData.get(stop.route_type)+1); // route_typeで集計
                nameFrameData.set(stop.route_name,nameFrameData.get(stop.route_name)+1); // route_nameで集計
            }
        })

        // 2.部分包囲のStop所属菌をカウント
        this.particals.map((stop) => {
            for (const bacteria of stop.bacterias){
                const d = distance([this.lng,this.lat],[bacteria.lng,bacteria.lat],{units: "meters"});
                if(d <= this.r){ // 集計対象内であれば
                    typeFrameData.set(stop.route_type,typeFrameData.get(stop.route_type)+1); // route_typeで集計
                    nameFrameData.set(stop.route_name,nameFrameData.get(stop.route_name)+1); // route_nameで集計
                }
            }
        })
        this.datas.push({timestamp: currentTimestamp, nameFrameData: nameFrameData, typeFrameData: typeFrameData});
        return false; // また未完(false)
    }


    /**
     * 集計対象のStop群を定義する
     * @param {*} lat 
     * @param {*} lng 
     * @param {*} allStops 
     * @param {*} r 
     * @returns 
     */
    static #defineTargetStop(lat, lng, allStops, r){
        const fullyContains = [];
        const particalContains = [];
        allStops.map((stop) => {
            const d = distance([lng, lat], [stop.lng, stop.lat], {units: "meters"}); // 計測中心からstopまでの距離
            if ( d < r - radiusuBuffer ){
                fullyContains.push(stop); // Stop所属菌を完全に内包
            } else if ( d < r + radiusuBuffer ) {
                particalContains.push(stop); // Stop所属菌を部分的に内包
            }
        })
        return {fully: fullyContains, partical: particalContains};
    }
}
export default Recorder;

